<template>
  <div class="details fade-in">
    <!-- Header Section -->
    <div class="header card shadow-sm border-0 mb-4">
      <div class="card-body">
        <div class="row align-items-center">
          <div class="col-md-8">
            <h3 class="text-primary mb-2">
              <i :class="'bi bi-' + icon + ' me-3'"></i>{{ title }}
            </h3>
            <h5 class="text-muted mb-3">{{ main.store.code }} - {{ main.store.name }}</h5>

            <div v-if="headerDetails.length > 0" class="d-flex flex-wrap gap-3 mb-2">
              <div class="info-item" v-for="detail in headerDetails" :key="detail.id">
                <i :class="'bi bi-' + detail.icon + ' text-primary me-2'"></i>
                <span class="text-muted">{{ detail.label }}:</span>
                <span v-if="detail.type !== 'status'" class="fw-medium ms-1">{{ getNestedValue(detail.key, detail?.type) }}</span>
                <Badge v-else pill :type="getStatusPill(getNestedValue(detail.key, detail?.type))" class="ms-2 status-badge-sm">
                  {{ getNestedValue(detail.key, detail?.type) }}
                </Badge>
              </div>
            </div>

            <div class="d-flex flex-wrap gap-3 mb-2">
              <div class="info-item">
                <i class="bi bi-person text-primary me-1"></i>
                <span class="text-muted">Created by:</span>
                <span class="fw-medium ms-1">{{ main.user.first_name }} {{ main.user.last_name }}</span>
              </div>

              <div class="info-item">
                <i class="bi bi-calendar-date text-primary me-1"></i>
                <span class="text-muted">Created at:</span>
                <span class="fw-medium ms-1">{{ formatDate(main.created_at) }}</span>
              </div>
            </div>
          </div>

          <div class="col-md-4 text-md-end mt-3 mt-md-0">
            <h4 v-if="main.code" class="text-muted mb-3">#{{ main.code }}</h4>
            <Badge pill :type="getStatusPill(main.status)" class="status-badge-lg">
              {{ main.status }}
            </Badge>
            <button class="btn btn-outline-dark ms-3" @click="$router.go(-1)">
              <i class="bi bi-arrow-left me-1"></i> Back
            </button>

            <div class="d-flex align-items-center justify-content-end mt-3">
              <!-- Files Section -->
              <div v-if="files && files.length > 0" class="mt-3">
                <div class="d-flex flex-wrap gap-2 align-items-center">
                  <span class="text-muted small"><i class="bi bi-paperclip me-1"></i>Attachment:</span>
                  <div v-for="file in files" :key="file.id" class="btn-group btn-group-sm">
                    <a
                      :href="file.url"
                      target="_blank"
                      class="btn btn-outline-primary btn-sm ms-2"
                      title="View file"
                    >
                      <i class="bi bi-download me-2"></i>{{ file.name }}
                    </a>
                  </div>
                </div>
              </div>
              <slot name="header-actions"></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formatDate from "../../utils/formatDate";

export default {
  name: "ProductDetailsHeader",

  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    main: {
      type: Object,
      required: true
    },
    headerDetails: {
      type: Array,
      default: () => []
    },
    files: {
      type: Array,
      default: () => []
    }
  },

  methods: {
    formatDate,
    getStatusPill(status) {
      switch (status) {
        case 'pending':
        case 'draft':
          return 'warning';
        case 'submitted':
          return 'primary';
        case 'complete':
        case 'paid':
          return 'success';
        case 'due':
          return 'secondary';
        default:
          return 'info';
      }
    },
    getNestedValue(data, type = 'string') {
      const value = data
          .split('.')
          .reduce((o, k) => o?.[k], this.main);

      if (type === 'date') {
          return this.formatDate(value);
      }

      return value;
    }
  }
}
</script>

<style scoped>
/* General styles */
.details {
  padding: 0.5rem;
}

.fade-in {
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Header styles */
.header {
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.header:hover {
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1) !important;
}

.info-item {
  display: flex;
  align-items: center;
  font-size: 0.9rem;
  background-color: #ffffff;
  border-radius: 20px;
  padding: 0.4rem 0.8rem;
}

.status-badge-lg {
  font-size: 1.1rem;
  padding: 0.5em 1em;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-badge-sm {
  font-size: 0.7rem;
  padding: 0.5em 1em;
  text-transform: uppercase;
}
</style>
